<template>
  <div class="main-content">

    <div class="row" v-if="!loading">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h6>Курьеры из Вашей группы</h6>
          </div>
          <div class="card-body">
            <SelectRunner
              ref="selectedRunner"
              :runners="runners"
              :useBackPacks="true"
              :runnerOrders="sortedOrders"
              :backPacks="backPacks"
              :updateSelectedRunner="(id) => this.selectedRunner = id"
            />
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <button class="btn btn-outline-info btn-sm" @click="getRecords">Обновить заявки</button>
          </div>
        </div>
      </div>
    </div>

    <div id="print_orders" v-if="!loading">
      <div v-for="(title, index) in displayListOfOrders" v-if="sortedOrders && sortedOrders[index] && sortedOrders[index].length > 0" v-bind:class="{'no_print': !showRunnerOrders[index]}">
        <div class="card">
          <div class="card-header">
            <h5>
              {{ title }} ({{ sortedOrders[index].length }})
              <button
                @click="showRunnerOrders[index] = !showRunnerOrders[index]"
                class="btn btn-default pull-right no_print"
              >
                {{ showRunnerOrders[index] ? "Скрыть" : "Показать" }}
              </button>
            </h5>
          </div>
          <div class="card-body" v-if="showRunnerOrders[index]">
            <OrderList
              :storeStatusByOrders="storeStatusByOrders"
              :orders="getSortedOrders(sortedOrders[index])"
              :selectedRunner="selectedRunner"
              :runnerId="index == 0 ? false : index"
              :runnerName="runners[selectedRunner]"
              :updateRootOrders="updateRootOrders"
              payMethod="cod_paid"
              :senders="senders"
            />
          </div>
          <div v-if="showRunnerOrders[index] && index > 0" class="card-footer text-right bg-custom-green">
            <LoadingButton
              title="сгенерировать файл"
              className="btn btn-outline-success btn-xs"
              :onClick="() => fileGenerate(index)"
              :loading="loadingSenderBtns[index]"
              :color="$constants.SUCCESS_COLOR"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-if="false" class="card">
      <div class="card-header" v-if="!loading">
        <h5>Отправители</h5>
      </div>
      <div class="card-body">
        <template v-if="loading">
          <pulse-loader :loading="true" :color="loadingColor" class="text-center"/>
        </template>
        <template v-else>
          <table class="table table-hover table-sm">
            <thead>
            <tr>
              <th></th>
              <th>Данные</th>
              <th>Лимит</th>
              <th>Использован</th>
              <th>Доступен</th>
              <!--              <th>Заявки</th>-->
            </tr>
            </thead>
            <tbody>
            <tr v-for="sender in senders" :key="sender.id">
              <td>{{ sender.order_num }}</td>
              <td>{{ sender.name }}({{ sender.id }}), {{ sender.phone }}</td>
              <td>{{ sender.sum_limit.toLocaleString('ru-RU') }}</td>
              <td>{{ sendersOrders[sender.id].limits.used.toLocaleString('ru-RU') }}</td>
              <td>{{ (sender.sum_limit - sendersOrders[sender.id].limits.used).toLocaleString('ru-RU') }}</td>
              <!--              <td>{{ sendersOrders[sender.id].orders.length }}</td>-->
            </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>

    <div class="card" v-if="false && !loading">
      <div class="card-header">
        <h5 class="pull-left">Заявки (наложенный платеж)</h5>
        <button @click="getRecords" class="btn btn-info btn-xs pull-right">Обновить заявки</button>
      </div>
      <div class="card-body">
        <div>
          <CodOrdersList
            ref="orders"
            :orders="orders"
          />
        </div>
        <div class="text-right">
          <button @click="appointOrders" type="button" class="btn btn-xs btn-success">Распределить выбранные заявки</button>
        </div>
      </div>
    </div>

    <div class="card" v-for="sender in senders" v-if="false && sendersOrders[sender.id] && sendersOrders[sender.id].orders.length && getSenderOrders(sender.id, true)">
      <div class="card-header">
        <h5>{{ sender.name }}</h5>
      </div>
      <div class="card-body">
        <CodOrdersList
          :ref="`orders_${sender.id}`"
          :appointed="true"
          :orders="getSenderOrders(sender.id)"
        />
      </div>
      <div class="card-footer text-right">
        <LoadingButton
          title="отметить отправленными"
          className="btn btn-outline-primary btn-xs"
          :onClick="() => updateOrders(sender.id, 'sendOrders')"
          :loading="loadingSenderBtns[sender.id]"
          :color="$constants.PRIMARY_COLOR"
        />
        <LoadingButton
          title="сгенерировать файл"
          className="btn btn-outline-success btn-xs"
          :onClick="() => fileGenerate(sender.id)"
          :loading="loadingSenderBtns[sender.id]"
          :color="$constants.SUCCESS_COLOR"
        />
      </div>
    </div>

  </div>
</template>

<script>

import api from "@/api";
import CodOrdersList from "@/components/orders/list/CodOrdersList";
import LoadingButton from "@/components/buttons/LoadingButton";
import SelectRunner from "@/components/runners/SelectRunner";
import * as _ from "lodash";
import moment from "moment";
import OrderList from "@/views/components/runners/OrderList";

export default {
  title: 'Наложенный платеж',
  components: {
    LoadingButton,
    CodOrdersList,
    SelectRunner,
    OrderList,
  },
  data() {
    return {
      loading: false,
      loadingSenderBtns: {},
      appointBtnLoading: false,
      loadingColor: this.$constants.LOADING_COLOR,
      orders: [],
      senders: [],
      runners: [],
      selectedRunner: null,
      sortedOrders: {},
      sendersOrders: {},
      showRunnerOrders: {},
      storeStatusByOrders: {},
      displayListOfOrders: {
        0: 'Не распределенные',
        sent: 'Отправленные'
      },
      backPacks: {},
    }
  },
  mounted() {
    this.getRecords();
  },
  methods: {
    updateRootOrders(type, ids, runnerId, toRunnerId, data = null, lineNum = null) {
      console.log(type, ids, runnerId, toRunnerId, data, lineNum);
      let orders
      switch (type) {
        case 'rejectOrder':
          orders = {...this.sortedOrders};
          orders[runnerId] = orders[runnerId].filter((o) => o.id !== ids);
          break;
        case 'assignOrders':
          orders = {...this.sortedOrders};
          const shiftedOrders = orders[runnerId].filter((o) => ids.includes(o.id + ''));
          orders[runnerId] = orders[runnerId].filter((o) => !ids.includes(o.id + ''));
          if (toRunnerId !== null) {
            if (!orders[toRunnerId]) {
              orders[toRunnerId] = [];
            }
            orders[toRunnerId] = [...orders[toRunnerId], ...shiftedOrders];
          }
          break;
      }

      if (lineNum) {
        orders[toRunnerId].forEach((o) => {
          if (lineNum[o.id]) {
            o.extra_options.line_order = lineNum[o.id];
          }
        })
        orders[runnerId].forEach((o) => {
          if (lineNum[o.id]) {
            o.extra_options.line_order = lineNum[o.id];
          }
        })
      }
      this.sortedOrders = {...orders};

    },
    getSortedOrders(orders) {
      return _.orderBy(orders, "deliveryTimestamp");
    },
    getSenderOrders(senderId, countOnly = false) {
      const orders = this.sendersOrders[senderId].orders.filter((o) => o.status === 1);
      return countOnly ? orders.length : orders;
    },
    async updateOrders(senderId, action) {
      switch (action) {
        case 'sendOrders':
          let selectedOrders = this.$refs['orders_' + senderId][0].selectedOrders;
          if (selectedOrders) {
            selectedOrders = Object.keys(selectedOrders).filter((k) => selectedOrders[k]);
          } else {
            return;
          }
          if (!selectedOrders.length) return;
          this.loadingSenderBtns[senderId] = true;
          const {data} = await api.post('/cod/updateOrders', {
            action,
            selectedOrders,
            senderId
          });
          if (data.success) {
            console.log(this.sendersOrders[senderId].orders, selectedOrders);
            this.sendersOrders[senderId].orders = this.sendersOrders[senderId].orders.filter((o) => !selectedOrders.includes(o.id + ''));
            console.log(this.sendersOrders[senderId].orders);

            this.sendersOrders[senderId] = {...this.sendersOrders[senderId]};
            toastr["success"]("Обновлено");
          } else {
            toastr["warning"](data.message || "Ошибка сервера");
          }
          break;
      }
      this.loadingSenderBtns[senderId] = false;
    },
    async fileGenerate(runnerId) {
      const {data} = await api.post('/cod/generateFile', {
        // senderId: senderId
        runner_id: runnerId
      });
      if (data && data.success) {
        window.location.href = data.link;
      } else {

      }
    },
    async appointOrders() {
      let selectedOrders = this.$refs.orders.selectedOrders;
      selectedOrders = Object.keys(selectedOrders).filter((oId) => selectedOrders[oId]);
      if (!selectedOrders || !selectedOrders.length) {
        toastr["warning"]("Выберите заявки");
        return;
      }
      this.appointBtnLoading = true;
      const {data} = await api.post('/cod/appointOrders', {
        selectedOrders
      });

      this.appointBtnLoading = false;
    },
    async getRecords() {
      this.loading = true;
      const {data} = await api.index('/cod/orders');
      if (data.success) {
        const loadingSenderBtns = {};
        this.sendersOrders = data.senders.reduce((acc, s) => {
          loadingSenderBtns[s.id] = false;
          acc[s.id] = {
            limits: {
              limit: s.sum_limit,
              used: _.sumBy(s.orders, 'price')
            },
            orders: s.orders
          }
          return acc;
        }, {});
        this.loadingSenderBtns = {...loadingSenderBtns};
        this.runners = data.runners;
        this.showRunnerOrders = Object.keys(data.runners).reduce((acc, id) => {
          acc[id] = false;
          return acc;
        }, {0: false, sent: false});
        this.storeStatusByOrders = data.storeStatusByOrders;
        this.sortedOrders = data.orders.reduce((acc, o) => {
          if (o.runner_id && !this.displayListOfOrders[o.runner_id]) {
            this.displayListOfOrders[o.runner_id] = this.runners[o.runner_id] || 'Не найден курьер';
          }
          if (o.status === 2) {
            if (!acc[o.runner_id]) {
              acc[o.runner_id] = [];
            }
            acc[o.runner_id].push({...o, deliveryTimestamp: moment(o.delivery_date).unix()});
          }
          if (o.status === 1) {
            if (!acc[0]) {
              acc[0] = [];
            }
            acc[0].push({...o, deliveryTimestamp: moment(o.delivery_date).unix()});
          }
          if (o.status === 7) {
            if (!acc.sent) {
              acc.sent = [];
            }
            acc.sent.push({...o, deliveryTimestamp: moment(o.delivery_date).unix()});
          }
          return acc;
        }, {})
        this.orders = data.orders;
        this.senders = data.senders;
        this.backPacks = data.backPacks;
      } else {
        toastr["warning"](data.message || "Ошибка сервера");
      }
      this.loading = false;
    }
  }
}
</script>

<style scoped>
.bg-custom-green {
  background-color: #e6f8e6;
}
</style>
